import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import {
    AccountNavLinkWrapper,
    AccountNavText,
} from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const LogInLinkNav = observer('LogInLinkNav', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const languagesState = LanguagesState.get(common);
    const language = languagesState.userLang ?? 'en';

    return (
        <AccountNavLinkWrapper
            dataTest='account-navigation-login'
            to={{ account: 'login', promo: null }}
            routeNameForGtm='login'
            variant={configState.componentVariants.accountNavVariant}
        >
            <UniverseComponent>
                {(universeModule): React.ReactElement => <universeModule.signInIcon />}
            </UniverseComponent>
            <AccountNavText
                lang={language}
                variant={configState.componentVariants.accountNavVariant}
            >
                <I18n
                    langKey='account.login'
                    defaultText='Login'
                />
            </AccountNavText>
        </AccountNavLinkWrapper>
    );
});
